module.exports = __webpack_public_path__ + "static/media/complex-5.05c44516.jpg";